import { all, put, take, takeEvery } from 'redux-saga/effects';
import { toggleStartNewMessage, openMessageForUser } from '../actions/room';
import { setDraftParticipants } from '../actions/drafts';
import { damzOnline } from '../actions/initialization';

function* handleOpenMessageFor(action: ReturnType<typeof openMessageForUser>) {
  const { user } = action.payload;

  if (user) {
    // Open new message window
    yield put(toggleStartNewMessage());

    // Set the target user as draft participant
    yield put(setDraftParticipants([user]));
  }
}

export function* openMessageForSaga() {
  // Wait for damz to be online before processing any openMessageFor logic
  yield take(damzOnline);

  yield all([takeEvery(openMessageForUser, handleOpenMessageFor)]);
}
